<template>
    <div style="padding-bottom: 40px;" class="container-fluid">
        <v-row>

            <!----------------- ROADMAP TIMELINE IN DESTOP VIEW --------------------->
            <v-col cols="12" class="d-none d-md-flex d-lg-flex d-xl-flex flex-column">
                <v-timeline 
                    style="padding: 0;" 
                    align-top
                >
                    <v-timeline-item
                        v-for="(item, index) in timelineItems"
                        :key="item.title"
                        small
                        color="#000000"
                        fill-dot
                        :left="(index + 1) % 2 !== 0"
                        :right="(index + 1) % 2 === 0"
                    >
                        <v-row
                            :class="{
                                'row-move-right': (index + 1) % 2 !== 0,
                                'row-move-left': (index + 1) % 2 === 0,
                            }"
                        >
                            <v-col
                                v-if="(index + 1) % 2 === 0"
                                lg="3"
                                mg="3"
                                sm="3"
                                cols="4"
                                class="p-0 center-connecting-line"
                            >
                                <div class="connecting-line"></div>
                            </v-col>
                            <v-col 
                                lg="9"
                                md="9"
                                sm="9"
                                cols="8"
                                class="p-0"
                            >
                                <div 
                                    :style="{ width: '100%', height: 'auto', marginBottom: '0px', }"
                                    class="timeline-item-container"
                                    :class="{
                                        'timeline-item-container-left': (index + 1) % 2 !== 0,
                                        'timeline-item-container-right': (index + 1) % 2 === 0,
                                    }"
                                >
                                    <!-------------------- ROADMAP TIMELINE TITLE IN DESKTOP VIEW -------------------->
                                    <v-chip 
                                        color="#000000"
                                        text-color="#FFFFFF"
                                        class="chip-size"
                                        large
                                    >
                                        {{ item.title }}
                                    </v-chip>

                                    <!----------------- ROADMAP TIMELINE TEXT CONTENT IN DESKTOP VIEW ---------------->
                                    <div
                                        v-if="!item.isVideoUnavailable"
                                        :class="{
                                            'timeline-item-text timeline-item-textContent-left': (index + 1) % 2 !== 0,
                                            'timeline-item-text timeline-item-textContent-right': (index + 1) % 2 === 0,
                                        }"
                                    >
                                        {{ item.content }}
                                    </div>

                                    <!--------------------- ROADMAP TIMELINE VIDEO IN DESKTOP VIEW ------------------->
                                    <RoadmapTimelineVideo
                                        :videoItem="item"
                                        :selectedVideoId="selectedVideoPlayingId"
                                        :isVideoPlayerPlayer="isVideoPlayerPlayer"
                                    />
                                </div>
                            </v-col>
                            <v-col
                                v-if="(index + 1) % 2 !== 0"
                                lg="3"
                                mg="3"
                                sm="3"
                                cols="4"
                                class="p-0 center-connecting-line"
                            >
                                <div class="connecting-line"></div>
                            </v-col>
                        </v-row>
                    </v-timeline-item>
                </v-timeline>

                <div class="w-100 flex-ctrl-container">
                    <v-btn
                        rounded
                        large
                        dark
                        color="#424EC4"
                        @click="goToLogin"
                    >
                    {{ isLoggedIn ? 'Proceed' : 'Proceed To Login' }}
                </v-btn>
                </div>
            </v-col>

            <!-------------------------------- ROADMAP TIMELINE IN MOBILE VIEW ----------------------------------->
            <v-col cols="12" class="d-flex d-none d-sm-flex d-sm-none d-md-none d-lg-none d-xl-none flex-column align-items-center timeline-container">

                <v-container 
                    fluid 
                    v-for="(item, index) in timelineItems" 
                    :key="item.title" 
                    class="timeline-mobile-item"
                >
                    <v-row class="d-flex justify-content-center">
                        <v-col 
                            class="timeline-mobile roadmap-timeline-item"
                            :class="{
                                'timeline-mobile-left-border-blank': (index + 1) % 2 === 0,
                                'timeline-mobile-right-border-blank': (index + 1) % 2 === 1,
                                'timeline-mobile-last': index + 1 === timelineItems.length, 
                                'timeline-mobile-last-left': index + 1 === timelineItems.length && (index + 1) % 2 === 1, 
                                'timeline-mobile-last-right': index + 1 === timelineItems.length && (index + 1) % 2 === 0 
                            }"
                        >
                            <!-------------------- ROADMAP TIMELINE TITLE IN MOBILE VIEW -------------------->
                            <v-chip 
                                color="#000000"
                                text-color="#FFFFFF"
                                class="chip-size timeline-mobile-chip"
                                :class="{
                                    'timeline-mobile-chip-left': (index + 1) % 2 === 0,
                                    'timeline-mobile-chip-right': (index + 1) % 2 === 1,
                                }"
                                large
                            >
                                {{ item.title }}
                            </v-chip>

                            <!----------------- ROADMAP TIMELINE TEXT CONTENT IN MOBILE VIEW ---------------->
                            <div
                                v-if="!item.isVideoUnavailable"
                                class="timeline-item-text my-4"
                                :class="{
                                    'timeline-item-textContent-right': (index + 1) % 2 === 0,
                                    'timeline-item-textContent-left': (index + 1) % 2 === 1,
                                }"
                            >
                                {{ item.content }}
                            </div>

                            <!--------------------- ROADMAP TIMELINE VIDEO IN MOBILE VIEW ------------------->
                            <RoadmapTimelineVideo
                                :videoItem="item"
                                :selectedVideoId="selectedVideoPlayingId"
                                :isVideoPlayerPlayer="isVideoPlayerPlayer"
                                :containerClass="'mb-5'"
                            />

                            <div v-show="index + 1 === timelineItems.length" class="flex-mobile-button">
                                <div 
                                    class="flex-fill" 
                                    :class="{ 
                                        'before-mobile-button': (index + 1) % 2 === 0, 
                                    }">
                                </div>
                                <div class="flex-ctrl-container">
                                    <v-btn
                                        rounded
                                        large
                                        dark
                                        color="#424EC4"
                                        @click="goToLogin"
                                    >
                                       {{ isLoggedIn ? 'Proceed' : 'Proceed To Login' }}
                                    </v-btn>
                                </div>
                                <div 
                                    class="flex-fill" 
                                    :class="{ 
                                        'after-mobile-button': (index + 1) % 2 === 1, 
                                    }">
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>

        </v-row>
    </div>
</template>

<script>
    import RoadmapTimelineVideo from './roadmap-timeline-video.vue';
    import { EventBus } from '../../../utils/eventBus';
    import { isLoggedIn } from '../../../utils/authentication';

    export default{
        name: "roadmap-timeline",
        props: {
            timelineItems: Array,
        },
        data(){
            return {
                selectedVideoPlayingId: null,
            };
        },
        components: {
            RoadmapTimelineVideo,
        },
        computed : {
            isLoggedIn() {
                console.log("user logged in :", isLoggedIn());
                
                return isLoggedIn();
            },
        },
        methods: {
            goToLogin(){
                if(this.isLoggedIn) {
                    this.$router.push("cyber-readiness-check");
                    EventBus.$emit("activate-indicated-menu-item", "cyber-readiness-check");
                    return;
                }
                this.$router.push("login");
                EventBus.$emit("activate-indicated-menu-item", "Sign In/Register");
            },
            isVideoPlayerPlayer(selectedVideoId ) {
                this.selectedVideoPlayingId = selectedVideoId;
            },
        },
    }
</script>

<style>
.v-timeline::before {
    left: calc(50% - 1px);
    right: auto;
    border: 1px dashed;
    border-color: black;
}
.timeline-item-container {
    position: relative;
    right: 0;
    bottom: 6px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;    
}
.timeline-item-container-left {
    align-items: flex-end;
}
.timeline-item-container-right {
    align-items: flex-start;
}
.chip-size {
    width: 280px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 10px;
    font-weight: 700;
    text-align: center;
    font-size: 18px !important;
    font-style: normal;
    line-height: normal
}
.timeline-item-textContent-left {
    text-align: right !important;
}
.timeline-item-textContent-right {
    text-align: left !important;
}
.timeline-item-text {
    width: 100%;
    height: auto;
    color: #5F5F5F;
    text-align: right;
    font-family: Rajdhani;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; 
    margin-top: 10px;
}
.v-timeline-item__dot--small {
    height: 14px;
    width: 14px;
}
.connecting-line {
    width: 100%;
    height: 1px;
    background-color: black;
    position: absolute;
    top: 20px;
}
.center-connecting-line {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}
.row-move-right {
    position: relative;
    left: 26px;
}
.row-move-left {
    position: relative;
    right: 26px;
}
.flex-ctrl-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.flex-ctrl-container .v-btn {
    min-width: 172px !important;
    height: 44px !important;
    text-transform: capitalize;
    color: #FFF;
    text-align: center;
    font-family: "GeomGraphic";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.1px;
}
.timeline-mobile-item {
    position: relative;
}
.timeline-mobile {
    max-width: 400px;
    min-width: 300px;
    border: 2px solid black;
    border-bottom: 0;
    position: relative;
}
.timeline-mobile-left-border-blank {
    border-left-width: 0 !important;
    border-right: 2px dashed black !important;
}
.timeline-mobile-right-border-blank {
    border-right-width: 0 !important;
    border-left: 2px dashed black !important;
}
.timeline-mobile-left-border-blank:before, 
.timeline-mobile-right-border-blank:after, 
.timeline-mobile-last-left:before, 
.timeline-mobile-last-right:after {
    content: '';
    width: 14px;
    height: 14px;
    position: absolute;
    border-radius: 50%;
    background-color: #000;
}
.timeline-mobile-left-border-blank:before {
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
}
.timeline-mobile-right-border-blank:after {
    top: 0;
    left: 0;
    transform: translate(-50%, -50%);
}
.timeline-mobile-chip {
    position: absolute;
    top: -30px;
}
.timeline-mobile-chip-right {
    right: 0;
}
.timeline-mobile-chip-left {
    left: 0;
}
.timeline-mobile-last {
    border-bottom: 2px solid black !important;
    position: relative;
}
.timeline-mobile-last-left:before {
    bottom: 0;
    left: 0;
    transform: translate(-50%, 50%);
}
.timeline-mobile-last-right:after {
    bottom: 0;
    right: 0;
    transform: translate(50%, 50%);
}
.flex-mobile-button {
    display: flex;
    flex-direction: row;
    width: 100%;
    position: absolute;
    bottom: -24px;
    left: 0;
}
.after-mobile-button, .before-mobile-button {
    background-color: white;
}
.top-block-cover {
    width: 27px; 
    background-color: white; 
    position: absolute; 
    top: 12px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    transform: translateX(-50%);
    z-index: 10;
}
.modal-roadmap-text {
    font-size: 20px;
    line-height: 3.5vh;
}
</style>